import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-008c21df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto danh-muc-vat-tu-form-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex align-items-center gap-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-text text-muted m-0" }, "(Tạo tự động)", -1))
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_8 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLoading = _resolveComponent("BaseLoading")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_TaiKhoanSelectionV2 = _resolveComponent("TaiKhoanSelectionV2")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DanhMucVatTuTable = _resolveComponent("DanhMucVatTuTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageContentBase, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.danhMucVatTuFormValue,
            rules: _ctx.rules,
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submit(false)), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tên nhóm")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "ten_danh_muc",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              ref: "tenDanhMucInputRef",
                              modelValue: _ctx.danhMucVatTuFormValue.ten_danh_muc,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.danhMucVatTuFormValue.ten_danh_muc) = $event)),
                              placeholder: "Tên nhóm",
                              name: "ten_danh_muc",
                              onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_LabelCustom, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Mã nhóm")
                            ]),
                            _: 1
                          }),
                          _hoisted_5
                        ]),
                        _createVNode(_component_el_form_item, {
                          prop: "ma_danh_muc",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.danhMucVatTuFormValue.ma_danh_muc,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.danhMucVatTuFormValue.ma_danh_muc) = $event)),
                              placeholder: "Mã nhóm",
                              name: "ma_danh_muc",
                              disabled: "",
                              onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 7
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_LabelCustom, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Mô tả")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "mo_ta",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.danhMucVatTuFormValue.mo_ta,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.danhMucVatTuFormValue.mo_ta) = $event)),
                              type: "textarea",
                              autosize: { minRows: 1 },
                              resize: "none",
                              placeholder: "Mô tả nhóm vật tư",
                              name: "mo_ta",
                              onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DivRow, { class: "mb-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_LabelCustom, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Tài khoản")
                          ]),
                          _: 1
                        }),
                        (_openBlock(), _createBlock(_component_TaiKhoanSelectionV2, {
                          key: _ctx.taiKhoanSelectionKey,
                          class: "w-100",
                          "ma-tai-khoan-prop": 
                    _ctx.taiKhoanData.maTaiKhoan
                      ? parseInt(_ctx.taiKhoanData.maTaiKhoan)
                      : undefined
                  ,
                          "ma-chi-tiet-prop": 
                    _ctx.taiKhoanData.maChiTiet ? _ctx.taiKhoanData.maChiTiet : undefined
                  ,
                          "ten-tai-khoan-prop": _ctx.taiKhoanData.tenTaiKhoan,
                          onOnClear: _ctx.onClearTaiKhoan,
                          onOnSelect: _ctx.onSelectTaiKhoan
                        }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop", "onOnClear", "onOnSelect"]))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DivRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    cols: 12,
                    "additional-class": "d-flex justify-content-center gap-x-2 my-4"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isCreating)
                        ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                            key: 0,
                            "button-type": _ctx.ButtonsType.ADD,
                            "color-type": _ctx.ButtonTypeColors.PRIMARY,
                            "is-loading": _ctx.isLoading,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submit(true)))
                          }, {
                            "button-label": _withCtx(() => [
                              _createTextVNode("Lưu và tiếp tục")
                            ]),
                            _: 1
                          }, 8, ["button-type", "color-type", "is-loading"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ButtonCustom, {
                        "button-type": _ctx.ButtonsType.SAVE,
                        "color-type": _ctx.ButtonTypeColors.SUCCESS,
                        "is-loading": _ctx.isLoading,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit(false)))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("Lưu")
                        ]),
                        _: 1
                      }, 8, ["button-type", "color-type", "is-loading"]),
                      _createVNode(_component_ButtonCustom, {
                        "button-type": _ctx.ButtonsType.REFRESH,
                        "color-type": _ctx.ButtonTypeColors.WARNING,
                        onClick: _ctx.clear
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("Nhập lại")
                        ]),
                        _: 1
                      }, 8, ["button-type", "color-type", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_DanhMucVatTuTable, {
              "cur-page": _ctx.currentPage,
              "is-readonly": false,
              items: _ctx.danhMucVatTuItems,
              loading: _ctx.tableLoading,
              "per-page": _ctx.perPage,
              "selected-id": _ctx.isCreating ? 0 : _ctx.danhMucVatTuId,
              onDeleteDanhMucVatTuSuccess: _ctx.fetchData
            }, null, 8, ["cur-page", "items", "loading", "per-page", "selected-id", "onDeleteDanhMucVatTuSuccess"]),
            (_ctx.danhMucVatTuItems.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  page: _ctx.currentPage,
                  "page-size": _ctx.perPage,
                  total: _ctx.totalItems,
                  onChangePage: _cache[9] || (_cache[9] = (value) => (_ctx.currentPage = value)),
                  onChangePageSize: _cache[10] || (_cache[10] = (value) => (_ctx.perPage = value))
                }, null, 8, ["page", "page-size", "total"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}